export const DATA_FETCH_ERROR: string = 'data.fetch.error';
export const PART_EXCHANGE_ERROR_NULL: string = 'partExchange.error.null';
